"use strict";

require("core-js/modules/es6.object.assign");

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  height: 1px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var HRStyle = styled_components_1["default"].hr(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.border["default"];
});
/**
 * Horizontal Rule <hr />
 */

var HR = function HR(props) {
  return react_1["default"].createElement(HRStyle, Object.assign({}, props));
};

exports["default"] = HR;